import { Box, IconButton, Stack } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { queryClient } from '../../App'
import { getImageSrc } from '../../helpers/getImageSrc'
import {
  checkEquipmentEverywhere,
  EQUIPMENT_KEYS,
} from '../../services/EquipmentApiService'
import { CheckEquipmentEverywhereRes } from '../../types/equipment.types'
import FormInput from '../../views/SingleRequestPage/components/SingleRequestDrawer/elements/FormInput'

interface EquipmentCheckingFieldProps {
  equipmentId: string
  defaultEquipmentId: string
  lastCheckedId: string
  error: boolean
  control: any
  onChecked: (data?: CheckEquipmentEverywhereRes, isReplaced?: boolean) => void
  withLabel?: boolean
  isReplaced?: boolean
  hideCheckBtn?: boolean
  disabled?: boolean
  checkDefault?: boolean
}

const EquipmentCheckingField: FC<EquipmentCheckingFieldProps> = ({
  equipmentId,
  onChecked,
  lastCheckedId,
  defaultEquipmentId,
  error,
  control,
  withLabel,
  isReplaced,
  hideCheckBtn,
  disabled,
  checkDefault,
}) => {
  const onCheckEquipment = async () => {
    const data = await queryClient.fetchQuery({
      queryKey: [EQUIPMENT_KEYS.CHECK_SN_EVERYWHERE, equipmentId],
      queryFn: () =>
        checkEquipmentEverywhere({
          smartCartId: equipmentId,
        }),
      gcTime: 0,
    })

    onChecked(data, isReplaced)
  }

  const isEquipmentIdChecked = lastCheckedId === equipmentId
  const isSameId = equipmentId === defaultEquipmentId && !checkDefault

  const showCheckedBtn =
    !hideCheckBtn &&
    !isEquipmentIdChecked &&
    !error &&
    !!equipmentId &&
    !isSameId

  const label = isReplaced ? 'ID нового оборудования' : 'ID оборудования'

  return (
    <Stack direction='row' alignItems={'center'} gap={'8px'}>
      <FormInput
        control={control}
        fullWidth
        name={isReplaced ? 'replacedEquipmentId' : 'equipmentId'}
        label={withLabel ? label : ''}
        placeholder='Введите ID оборудования'
        onlyNumbers
        disabled={disabled}
      />
      {showCheckedBtn && (
        <IconButton sx={iconBtnSx} onClick={() => onCheckEquipment()}>
          <Box component={'img'} src={getImageSrc('check')} sx={checkSx} />
        </IconButton>
      )}
    </Stack>
  )
}

const iconBtnSx = {
  padding: '8px',
  background: 'rgba(217, 217, 217, 0.30)!important',
}
const checkSx = { height: '18px', width: '18px', opacity: '.8' }

export default observer(EquipmentCheckingField)
